import { Button } from "@mui/material";
import { ContextFromSelections, ReadyToCheckout } from "./Context";
import { useContext, useEffect, useState } from "react";
import {Box} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "./Context";
import { useNotify } from "./Utils";
import {Divider} from "@mui/material";





function ButtonForSumbitt() {
    
    const [userData] = useContext(UserDataContext)
    const [isReady, setIsReady] = useContext(ReadyToCheckout)
    const [selections]  = useContext(ContextFromSelections)
    const [fieldschecked, setFieldsChecked] = useState(false)
    const [calculatedPrice, setCalculatedPrice] = useState(null)
    const navigate = useNavigate()
    const notify = useNotify()


   
    useEffect(() => {
        setIsReady(fieldschecked);
    },[fieldschecked])
    
    useEffect(() => {
        calculatePriceByLenght();
    },[selections.ribbonLenght])


    const requiredfileds = {
        "Color": selections.ribbonColor,
        "Width": selections.ribbonWidth,
        "Lenght": selections.ribbonLenght,  
        "Print color": selections.fontColor,
    }
    const OrAndRequiredFields = (selections.uploaded_file || (selections.textOnRibbon));

    
    

    const calculatePriceByLenght = async() => {
        if (selections.ribbonLenght) {

        try {
            const fetching = await fetch(`${process.env.REACT_APP_API_URL}/calculateprice`,{
                "method": "POST",
                "headers": {
                    "Content-Type": "application/json",
                },
                "body": selections.ribbonLenght

            })
            if (fetching.ok) {
                const resp = await fetching.json();
                setCalculatedPrice(resp)
            }
            
            else {
                console.log(fetching.statusText)
                return;
            }
            
        }
        catch (error) {
            console.log(error)
            return;
        }
        
        }
        else {
            return;
        }
    };

    
    
    
    

    


    const checkFields = () => {
        let message = "Please Choose  :";
        Object.keys(requiredfileds).forEach((field) => {
            if (!requiredfileds[field]) {
                message += `\n${field},`
            }

        })
        if (!OrAndRequiredFields) {
            message += "Upload Your Logo  or Add Text";
        }
        if (
            (Object.values(requiredfileds).every((fields) => fields)) && 
            (OrAndRequiredFields))
        {
            setFieldsChecked(true)
            return notify({message: "nessesary fields are selected",variant:"success"})
        }
        return notify({message: message.replace(/,$/, ""),variant: "info"})
    }
    useEffect(() => {
       if (Object.values(requiredfileds).some((fields) => !fields) || (!OrAndRequiredFields))
        {setFieldsChecked(false)}
    },[requiredfileds,OrAndRequiredFields])
    

    const gotoCheckout = () => {
        if (!userData.userIsLogin) {
            return navigate("/signin")
        }
        else {
            return navigate("/checkout")
        }
    }

    return(
        <div>
        <Box
            margin='auto'
            display='flex'
            justifyContent='center'
            
            sx={{
                
                border: {md: "1px solid",xs: ""},
                borderColor: {md: "divider", xs: ""},
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                gap:3,
                p:2,
                // border: "2px solid blue"
            }}
            
        >
            <Button
                variant="contained"
                color="success"
                onClick={checkFields}
                sx={{
                    display: fieldschecked ? 'none' : null,
                    width: {xs: "100%",sm: 350},
                    height: {sm: 45, xs: 45},
                    fontSize: 16,
                   
                }}
                >
            Checkout
        </Button>

        {fieldschecked && 
        <Button
            variant="contained"
            color="success"
            endIcon={<CheckIcon/>}

            sx={{
                width: {xs: "100%",sm: 350},
                height: {sm: 45, xs: 45},
            }}
            onClick={() => {
                gotoCheckout()}}
            >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <span style={{fontSize: 14}}>Proceed to Payment </span>
                <span style={{fontSize: 9.5}}>Product price is {calculatedPrice / 100} us $</span>
            </div>
        </Button>
        }
       
        
        

        </Box>
        <Divider sx={{
            m:2,
            display: {md: "none"}}}/>
        </div>
        
    )

}

export default function SubmittSelections() {
    return(
        
            <ButtonForSumbitt/>
        
    )
    
}